import Banner from "@/components/banner";
import TitleBox from "@/components/title.vue";
import Address from "@/components/address.vue";
import RealCase from "@/components/real-case.vue";
export default {
  name: "about-us",
  components: {
    Banner,
    TitleBox,
    Address,
    RealCase
  },
  data() {
    return {
      bannerImg: require("@/assets/cooperation-join/banner.png"),
      intelligent: [
        {
          content:
            "技术基础趋于成熟<br>移动支付普及率已高达53%<br>智能技术已逐步成熟",
          img: require("@/assets/cooperation-join/intelligent-bg1.png")
        },
        {
          content:
            "实体经济成本一路攀高<br>2021年中国员工薪酬增长8%<br>2020年中国总体租金增长7%",
          img: require("@/assets/cooperation-join/intelligent-bg2.png")
        }
      ],
      automationUl: [
        {
          content: "消费者体验提升",
          img: require("@/assets/cooperation-join/automation1.png")
        },
        {
          content: "新型支付场景",
          img: require("@/assets/cooperation-join/automation2.png")
        },
        {
          content: "行业效率提升",
          img: require("@/assets/cooperation-join/automation3.png")
        },
        {
          content: "线下流量人口",
          img: require("@/assets/cooperation-join/automation4.png")
        }
      ],
      automationContent: {
        img: require("@/assets/cooperation-join/automation-content.png"),
        title: "最先拥抱智能化转型的行业具备以下特征",
        content: ["人力附加值低，现有体验差", "行业利润厚", "玩家分散"]
      },
      openMarkets: [
        {
          content: "北京",
          num: "7600"
        },
        {
          content: "上海",
          num: "5300"
        },
        {
          content: "其他省份",
          num: "5000"
        }
      ],
      outPut: [
        {
          content: "快印业务",
          sum: "¥240亿"
        },
        {
          content: "其他业务",
          sum: "¥560亿"
        }
      ],
      outPutImg: require("@/assets/cooperation-join/pie.png"),
      closedMarketLeft: [
        {
          sum: "2500所",
          img: require("@/assets/cooperation-join/closedMarket2.png")
        },
        {
          sum: "3800万",
          img: require("@/assets/cooperation-join/closedMarket1.png")
        }
      ],
      closedMarketRight: [
        {
          content: "单机年收入",
          sum: "¥3万"
        },
        {
          content: "校园市场营收规模",
          sum: "¥23亿"
        }
      ],
      singleMachineModel: [
        {
          img: require("@/assets/cooperation-join/singleMachineModel1.png"),
          content: "日单量(0.25元/张)",
          unit: "500+"
        },
        {
          img: require("@/assets/cooperation-join/singleMachineModel2.png"),
          content: "单机月利润率(成本均摊后净利/收入)",
          unit: "35+%"
        },
        {
          img: require("@/assets/cooperation-join/singleMachineModel3.png"),
          content: "回本周期(月)",
          unit: "3-6"
        },
        {
          img: require("@/assets/cooperation-join/singleMachineModel4.png"),
          content: "年利润(万元)",
          unit: "2.5+"
        }
      ],
      terminalLaying: [
        {
          content: "2020年1月",
          sum: "100+"
        },
        {
          content: "2021年12月",
          sum: "5000+"
        },
        {
          content: "2025年底",
          sum: "10000+"
        }
      ],
      businessModel: [
        {
          img: require("@/assets/cooperation-join/businessModel1.png"),
          title: "自主经营",
          content:
            "公司自主开发的投放点位, .如:用户邀 约、BD推广、用户 推荐、投标等。"
        },
        {
          img: require("@/assets/cooperation-join/businessModel2.png"),
          title: "分成经营",
          content:
            "可根据需求共同讨论合作方式及分成比例，此方案更适合高校、连锁店、高端连锁商务酒店等高人流量的场景."
        },
        {
          img: require("@/assets/cooperation-join/businessModel3.png"),
          title: "买断经营",
          content:
            "主要是以买断多拉打印终端设备为主（不包含多拉打印系统），适用于自主经营需求的个人或者团体设计，投放场景不限，前提是买断经营需向多拉厂商按年或者按经营流水支付系统使用费及管理费."
        }
      ],
      carouselList: [
        require("@/assets/college/live1.png"),
        require("@/assets/college/live2.png"),
        require("@/assets/college/live3.png"),
        require("@/assets/convenience/live1.png"),
        require("@/assets/convenience/live2.png"),
        require("@/assets/convenience/live3.png")
      ]
    };
  },
  methods: {}
};
